import { useQueries, useQuery } from '@tanstack/react-query';
import { getDataQuery } from 'api';
import { getSessionStorage } from 'assets/constant';
import { jwtDecode } from 'jwt-decode';

export const useAdminUserSetting = (data) => {
  const token = getSessionStorage('accessToken');
  const decoded = jwtDecode(token);

  const adminUserSettingApi = useQueries({
    queries: [
      {
        queryKey: ['adminUserProfile', decoded],
        queryFn: () => getDataQuery(`/admin/users/count`),
      },
      {
        queryKey: ['adminUserProfile', decoded, data],
        queryFn: () => getDataQuery(`/users?id=${data}`),
        enabled: !!data,
      },
    ],
  });

  // 전체 유저 데이터 (프론트엔드 페이징 + 엑셀 다운로드용)
  const adminUserAll = useQuery({
    queryKey: ['adminUserAll'],
    queryFn: () => getDataQuery(`/admin/users/list/all`),
  });

  const [adminAlluserLength, adminUserProfile] = adminUserSettingApi;
  const [adminAlluserLengthData, adminUserProfileData] = adminUserSettingApi.map(
    (query) => query?.data?.data
  );
  const adminUserAllData = adminUserAll?.data?.data;

  const { isLoading: adminAlluserLengthIsLoading, isError: adminAlluserLengthIsError } = adminAlluserLength;
  const { isLoading: adminUserAllIsLoading, isError: adminUserAllIsError } = adminUserAll;
  const { isLoading: adminUserProfileIsLoading, isError: adminUserProfileIsError } = adminUserProfile;

  return {
    // 어드민 전체 유저 카운트
    adminAlluserLengthData,
    adminAlluserLengthIsLoading,
    adminAlluserLengthIsError,

    // 전체 유저 데이터 (프론트엔드 페이징 + 엑셀 다운로드용)
    adminUserAllData,
    adminUserAllIsLoading,
    adminUserAllIsError,

    // LearningBoardAccount.jsx 호환용 별칭
    adminAllUserData: adminUserAllData,
    adminAllUserIsLoading: adminUserAllIsLoading,
    adminAllUserIsError: adminUserAllIsError,
    adminUserExcelData: adminUserAllData,
    adminUserExcelIsLoading: adminUserAllIsLoading,
    adminUserExcelIsError: adminUserAllIsError,

    // 어드민이 유저의 정보 조회 api (특정 유저)
    adminUserProfileData,
    adminUserProfileIsLoading,
    adminUserProfileIsError,
  };
};
